<ion-modal
  [isOpen]="foodCostCalculatorService.showFoodCostReportDetailsModal | async"
  [ngClass]="
    platformService?.platformType !== platformService?.platformEnum?.desktop
      ? 'ion-modal-touch modal-sheet'
      : 'ion-header-modal-desktop modal-desktop-size-md'
  "
  [initialBreakpoint]="
    platformService.platformType !== platformService.platformEnum.desktop
      ? 1
      : undefined
  "
  [breakpoints]="
    platformService.platformType !== platformService.platformEnum.desktop
      ? [0, 1]
      : undefined
  "
  (didDismiss)="onDidDismiss()"
>
  <ng-template>
    <ion-header
      class="ion-no-border"
      [ngClass]="
        platformService?.platformType !== platformService?.platformEnum?.desktop
          ? platformService?.platformType ===
            platformService?.platformEnum?.tablet
            ? 'ion-header-modal-tablet'
            : 'ion-header-modal-mobile'
          : 'ion-header-modal-desktop'
      "
    >
      <ion-toolbar>
        <ion-buttons
          *ngIf="
            platformService?.platformType ===
            platformService?.platformEnum?.desktop
          "
          slot="end"
        >
          <ion-button
            data-cy="close-food-cost-report-details-modal-button"
            (click)="dismissModal()"
          >
            <ion-icon slot="icon-only" name="close-outline"></ion-icon>
          </ion-button>
        </ion-buttons>
        <ion-label class="bold title" data-cy="extended-cost-report-label">
        </ion-label>
      </ion-toolbar>
    </ion-header>
    <ion-content
      scroll-y="false"
      data-cy="food-cost-report-details-modal-area-text"
      class="content"
      [ngClass]="
        platformService?.platformType !== platformService?.platformEnum?.desktop
          ? platformService?.platformType ===
            platformService?.platformEnum?.tablet
            ? 'ion-content-modal-tablet'
            : 'ion-content-modal-mobile'
          : 'ion-content-modal-desktop'
      "
      tabletTouchMove
    >
      <ion-grid>
        <ion-row class="report-details">
          <ion-col>
            <h3>
              {{
                'i18n.inventory.costReportDetailsModal.reportDetails'
                  | translate
              }}
            </h3>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col>
            <div class="food-cost-target">
              <app-food-cost-target
                data-cy="food-cost-report-details-modal-target"
                [foodCostTarget]="foodCostReport?.target"
                [displayIcon]="false"
              >
              </app-food-cost-target>
            </div>
          </ion-col>
        </ion-row>
        <ion-row
          *ngIf="
            platformService?.platformType !==
            platformService?.platformEnum?.mobile
          "
        >
          <ion-col>
            <p>
              <span class="report-heading">
                {{ 'i18n.inventory.foodCost.dateRange' | translate }}:
              </span>
              <span class="report-data"
                >{{
                  foodCostReport?.startPeriod | date: 'M/d/yyyy'
                }}&nbsp;-&nbsp;{{
                  foodCostReport?.endPeriod | date: 'M/d/yyyy'
                }}</span
              >
            </p>
            <p>
              <span class="report-heading">
                {{
                  'i18n.inventory.foodCost.usfPurchaseForPeriod' | translate
                }}:
              </span>
              <span class="report-data">{{
                foodCostReport?.usfProductsPurchaseAmount
                  ? (foodCostReport?.usfProductsPurchaseAmount | currency)
                  : (0.0 | currency)
              }}</span>
            </p>
            <p>
              <span class="report-heading">
                {{
                  'i18n.inventory.foodCost.salesRevenueForPeriod' | translate
                }}:
              </span>
              <span class="report-data">{{
                foodCostReport?.salesRevenue
                  ? (foodCostReport?.salesRevenue | currency)
                  : (0.0 | currency)
              }}</span>
            </p>
            <p>
              <span class="report-heading"
                >{{
                  'i18n.inventory.foodCost.beginningInventories' | translate
                }}:</span
              >
            </p>
            <ul *ngFor="let inv of foodCostReport?.startingInventory">
              <li class="report-data">{{ inv?.inventoryName }}</li>
            </ul>
          </ion-col>
          <ion-col>
            <p>
              <span class="report-heading">
                {{ 'i18n.inventory.foodCost.dateCreated' | translate }}:
              </span>
              <span class="report-data"
                >{{
                  foodCostReport?.r4AddDtm | date: 'M/d/yyyy'
                }}&nbsp;at&nbsp;{{
                  foodCostReport.r4AddDtm | date: 'shortTime'
                }}</span
              >
            </p>
            <p>
              <span class="report-heading">
                {{
                  'i18n.inventory.foodCost.otherPurchasesForPeriod' | translate
                }}:
              </span>
              <span class="report-data">{{
                foodCostReport?.nonUsfProductsPurchaseAmount
                  ? (foodCostReport?.nonUsfProductsPurchaseAmount | currency)
                  : (0.0 | currency)
              }}</span>
            </p>
            <p>
              <span class="report-heading">
                {{
                  'i18n.inventory.foodCost.foodCostPercentageFull' | translate
                }}:
              </span>
              <span class="report-data"
                >{{ foodCostReport?.foodCostPercentage }}%</span
              >
            </p>
            <p>
              <span class="report-heading"
                >{{
                  'i18n.inventory.foodCost.endInventories' | translate
                }}:</span
              >
            </p>
            <ul *ngFor="let inv of foodCostReport?.endInventory">
              <li class="report-data">{{ inv?.inventoryName }}</li>
            </ul>
          </ion-col>
        </ion-row>

        <!-- Mobile Food Cost Data -->
        <ion-row
          *ngIf="
            platformService?.platformType ===
            platformService?.platformEnum?.mobile
          "
        >
          <p>
            <span class="report-heading">
              {{ 'i18n.inventory.foodCost.dateRange' | translate }}:
            </span>
            <span class="report-data"
              >{{
                foodCostReport?.startPeriod | date: 'M/d/yyyy'
              }}&nbsp;-&nbsp;{{
                foodCostReport?.endPeriod | date: 'M/d/yyyy'
              }}</span
            >
          </p>
          <p>
            <span class="report-heading">
              {{ 'i18n.inventory.foodCost.dateCreated' | translate }}:
            </span>
            <span class="report-data"
              >{{ foodCostReport?.r4AddDtm | date: 'M/d/yyyy' }}&nbsp;at&nbsp;{{
                foodCostReport.r4AddDtm | date: 'shortTime'
              }}</span
            >
          </p>
          <p>
            <span class="report-heading">
              {{ 'i18n.inventory.foodCost.usfPurchaseForPeriod' | translate }}:
            </span>
            <span class="report-data">{{
              foodCostReport?.usfProductsPurchaseAmount
                ? (foodCostReport?.usfProductsPurchaseAmount | currency)
                : (0.0 | currency)
            }}</span>
          </p>
          <p>
            <span class="report-heading">
              {{
                'i18n.inventory.foodCost.otherPurchasesForPeriod' | translate
              }}:
            </span>
            <span class="report-data">{{
              foodCostReport?.nonUsfProductsPurchaseAmount
                ? (foodCostReport?.nonUsfProductsPurchaseAmount | currency)
                : (0.0 | currency)
            }}</span>
          </p>
          <p>
            <span class="report-heading">
              {{ 'i18n.inventory.foodCost.salesRevenueForPeriod' | translate }}:
            </span>
            <span class="report-data">{{
              foodCostReport?.salesRevenue
                ? (foodCostReport?.salesRevenue | currency)
                : (0.0 | currency)
            }}</span>
          </p>
          <p>
            <span class="report-heading">
              {{
                'i18n.inventory.foodCost.foodCostPercentageFull' | translate
              }}:
            </span>
            <span class="report-data"
              >{{ foodCostReport?.foodCostPercentage }}%</span
            >
          </p>
          <div>
            <p>
              <span class="report-heading"
                >{{
                  'i18n.inventory.foodCost.beginningInventories' | translate
                }}:</span
              >
            </p>
            <ul *ngFor="let inv of foodCostReport?.startingInventory">
              <li class="report-data">{{ inv?.inventoryName }}</li>
            </ul>
          </div>
          <div>
            <p>
              <span class="report-heading"
                >{{
                  'i18n.inventory.foodCost.endInventories' | translate
                }}:</span
              >
            </p>
            <ul *ngFor="let inv of foodCostReport?.endInventory">
              <li class="report-data">{{ inv?.inventoryName }}</li>
            </ul>
          </div>
        </ion-row>
      </ion-grid>
    </ion-content>
    <ion-footer
      class="ion-footer-modal"
      [class.ion-footer-modal-desktop]="
        platformService?.platformType === platformService?.platformEnum?.desktop
      "
    >
      <ion-toolbar>
        <ion-buttons>
          <ion-button
            data-cy="food-cost-report-details-modal-cancel-button"
            [ngClass]="
              platformService?.platformType !==
              platformService?.platformEnum?.mobile
                ? 'usf-outline-green-dsktp-tblt-modal-button'
                : 'usf-outline-green-mobile-modal-button'
            "
            (click)="dismissModal()"
          >
            {{ 'i18n.common.cancel' | translate }}
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-footer>
  </ng-template>
</ion-modal>
